"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncate = exports.matchPresenterName = exports.configureStoreForTest = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _redux = require("redux");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var truncate = exports.truncate = function truncate(text) {
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 22;
  return text.length <= maxLength ? text : "".concat(text.slice(0, maxLength - 3), "...");
};

/**
 * Small function to convert string to lowercase
 * @param {*} str: String | undefined;
 * @returns String | undefined;
 */
function toLowerCase(str) {
  return str && (str === null || str === void 0 ? void 0 : str.toLowerCase());
}

/**
 * Small function to match a knock presenter name to a source title/name
 * @param {*} knockName: String;
 * @param {*} source: String;
 * @returns boolean
 */
var matchPresenterName = exports.matchPresenterName = function matchPresenterName(knockName, source) {
  var _knockName = toLowerCase(knockName);
  var _sourceTitle = toLowerCase(source.title);

  /** Exact match of presenter name and source title */
  return _knockName === _sourceTitle;
};

/**
 * Small function to help configure store for testing and mocks
 * @param {Object} reducer;
 * @param {Object} initialState;
 * @param {Array} middleware;
 * @param {Array} enhancers;
 * @returns {Object} store
 */
var configureStoreForTest = exports.configureStoreForTest = function configureStoreForTest(reducer) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var middleware = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var enhancers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var reducers = function reducers() {
    return (0, _redux.combineReducers)(_objectSpread({}, reducer));
  };
  var composedEnhancers = _redux.compose.apply(void 0, [_redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2["default"])(middleware))].concat((0, _toConsumableArray2["default"])(enhancers)));
  return (0, _redux.createStore)(reducers, initialState, composedEnhancers);
};